// extracted by mini-css-extract-plugin
export var container = "styles-module--container--6cda2";
export var headlineContainer = "styles-module--headlineContainer--54e7c";
export var headlineOuterContainer = "styles-module--headlineOuterContainer--cbcd0";
export var subheadline = "styles-module--subheadline--732f8";